module.exports = __webpack_public_path__ + "img/pro2.40f5be92.png";